import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'relements/build/esm/ui/icon';
import HelperUtils from '@haptik/helpers/build/esm/platformUtils';

import NodeIcon from '../../icons/node.svg';
import SubStoryIcon from '../../icons/substory.svg';
import StoryIcon from '../../icons/story.svg';
import UserSaysIcon from '../../icons/usersays.svg';
import BotSaysIcon from '../../icons/botsays.svg';
import styles from './Result.scss';

const TYPES = {
  USER_SAYS: 'user_responses',
  BOT_SAYS: 'bot_responses',
  GENERIC_RESPONSE: 'generic_responses',
  NODE: 'nodes',
  SUBSTORY: 'sub_stories',
  STORY: 'stories',
};

const TYPE_MAP = {
  [TYPES.USER_SAYS]: 'User Messages',
  [TYPES.BOT_SAYS]: 'Bot Responses',
  [TYPES.NODE]: 'Step',
  [TYPES.SUBSTORY]: 'Skill',
  [TYPES.STORY]: 'Skill Set',
  [TYPES.GENERIC_RESPONSE]: 'Generic Response',
};

const ICON_MAP = {
  [TYPES.USER_SAYS]: UserSaysIcon,
  [TYPES.BOT_SAYS]: BotSaysIcon,
  [TYPES.NODE]: NodeIcon,
  [TYPES.SUBSTORY]: SubStoryIcon,
  [TYPES.STORY]: StoryIcon,
  [TYPES.GENERIC_RESPONSE]: BotSaysIcon,
};

function getHighlightedHTML(value, highlight, pattern) {
  const escapedPattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  return value.replace(
    new RegExp(`(${escapedPattern})`, 'gi'),
    '<strong>$1</strong>'
  );
}

function Result({
  id,
  type,
  value,
  highlight,
  parent,
  parentType,
  pattern,
  onClick,
}) {
  return (
    <div onClick={e => onClick(id, type, e)} className={styles.result}>
      <Icon className={styles.resultIcon} src={ICON_MAP[type]} />
      <div className={styles.resultText}>
        <div
          className={styles.resultTextTitle}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: getHighlightedHTML(HelperUtils.htmlEscape(value), highlight, pattern),
          }}
        />
        <div className={styles.resultTextSubtitle}>
          <strong>{TYPE_MAP[type]}</strong>
          {' '}
          in
          {parentType}
          :
          {parent}
        </div>
      </div>
    </div>
  );
}

Result.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  highlight: PropTypes.string,
  parent: PropTypes.string,
  parentType: PropTypes.string,
  pattern: PropTypes.string,
  onClick: PropTypes.func,
};

Result.defaultProps = {
  id: '',
  type: '',
  value: '',
  highlight: '',
  parent: '',
  parentType: '',
  pattern: '',
  onClick: () => {},
};

Result.TYPES = TYPES;

export default Result;
